import { render, staticRenderFns } from "./CatalogModal.vue?vue&type=template&id=63d2e800&scoped=true&"
import script from "./CatalogModal.vue?vue&type=script&lang=js&"
export * from "./CatalogModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogModal.vue?vue&type=style&index=0&id=63d2e800&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d2e800",
  null
  
)

export default component.exports